// extracted by mini-css-extract-plugin
export var chevron = "_ml-3";
export var chevronRotated = "_ml-4";
export var image = "_ml-1";
export var imageContainer = "_ml-0";
export var shippingAddress = "_ml-2";